export default __webpack_public_path__ + "static/media/chubb-logo-dark.ef69e16a.svg";